import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-142" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-143" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-144" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-145" data-mp="tyv5tcf1sfy9">🏆 </span>Offre Spéciale de Lancement
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-146" data-mp="u0xvtwg7a92z">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-147" data-mp="13x14zm9gz7zf">
            Pack FRANÇAIS PRÊT™
          </span>

          <dl data-id="element-148" data-mp="2fbofq5tz1egx">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-149" data-mp="2feano6krxvzo">
                <dt className="text-ink/80" data-id="element-150" data-mp="pjfkqbzwipjp">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-151" data-mp="uj1ycmjn67t1">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-152" data-mp="ziocqzb7hu3f">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-153" data-mp="13ki7ys2mu5w7">
                Valeur Totale :
              </dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-154" data-mp="6usevr9whw52">225€</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-155" data-mp="btlvhskhi39g">
            Seulement aujourd&apos;hui
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-156" data-mp="kkvz6cp7zfrv">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-157" data-mp="3k8vv8u0wiwe2">
              🏆
            </span>
            <span className="flex items-baseline gap-1.5 font-display font-black leading-none text-brand" data-id="element-158" data-mp="3o9pjjoi9ad7h">
              <span className="text-6xl sm:text-7xl" data-id="element-159" data-mp="veyzwmtrt6zt">27</span>
              <span className="text-lg font-bold tracking-[0.08em] sm:text-xl" data-id="element-160" data-mp="qgnqgd7e0yi4">
                USD
              </span>
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-161" data-mp="1548ty886czqk">
            <span aria-hidden="true" data-id="element-162" data-mp="107s4nap8ofbw">💳 </span>Paiement unique, accès à vie.
            Aucun abonnement.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-163" data-mp="ch4vyn7i1loa" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-164" data-mp="7ibgip8njklh">
            Téléchargement Instantané · Paiement Unique · Accès à Vie ·
            Garantie de 7 Jours
          </p>
        </div>
      </div>
    </section>;
}